export default __webpack_public_path__ + "static/media/card-icon.9ab93a94.svg";